import { render, staticRenderFns } from "./quest-header.vue?vue&type=template&id=20f9176f"
import script from "./quest-header.vue?vue&type=script&lang=js"
export * from "./quest-header.vue?vue&type=script&lang=js"
import style0 from "./quest-header.vue?vue&type=style&index=0&id=20f9176f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports